import angular from 'angular';

import ColorPaletteModule from './color-palette/color-palette';

const ConstantModule = angular.module('control-room.commons.basic.constant', [ColorPaletteModule.name]);

export default ConstantModule;
